module.exports = __webpack_public_path__ + "static/media/beaming-face-with-smiling-eyes-svgrepo-com.a1fe9c79.svg";